import {z} from 'zod';
import {LabelValueSchema} from '@netx/core-next/schema/common';
import {GroupType} from '@netx/core-system-groups/schema';

export const GroupAutoListItemSchema = LabelValueSchema.pick({
	label: true,
}).extend({
	// we need to move away from these lbvs
	// in our api layer we will be sure to at least parse this to an int
	value: z.number().int().positive(),
	type: z.nativeEnum(GroupType).optional(),
});

export type IGroupAutoListItem = z.infer<typeof GroupAutoListItemSchema>;
